import React from "react";
import "./ToggleSwitch.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const ToggleSwitch = ({ meetingId, activeSwitchId, handleActiveSwitchId }) => {
  const handleToggle = () => {
    if (activeSwitchId && activeSwitchId !== meetingId) {
      return false;
    }
    handleActiveSwitchId(activeSwitchId == meetingId ? null : meetingId);
  };

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip className="custom-tooltip">
          {activeSwitchId && activeSwitchId !== meetingId
            ? "Another meeting is already being recorded. Kindly stop that recording before starting this one."
            : (activeSwitchId === meetingId ? "Click to Stop Meeting" : "Click to Record Meeting" )}
        </Tooltip>
      }
    >
      <div className="toggle-switch" key={`toggle_switch_id_${meetingId}`}>
        <label className="switch">
          <input
            type="checkbox"
            checked={activeSwitchId === meetingId}
            readOnly
          />
          <span className="slider round" onClick={handleToggle}></span>{" "}
        </label>
      </div>
    </OverlayTrigger>
  );
};

export default ToggleSwitch;
